import { del, get, patch, post } from '../../utils/api'
import { AxiosResponse } from 'axios'
import { DataCreateBlockType, UpdateBlockDataType } from './types'

export const fetchLesson = (lid: string): Promise<AxiosResponse> =>
  get(`/courses/lessons/${lid}`, {
    include: [
      'blocks',
      'blocks.gallery',
      'blocks.files',
      'blocks.links',
      'blocks.videos',
      'blocks.notion',
      'blocks.simpleTask',
      'blocks.simpleTask.task.userSimpleTask',
    ].join(','),
  })

export const updateBlock = (
  block_id: string,
  data: UpdateBlockDataType
): Promise<AxiosResponse> => patch(`/courses/blocks/${block_id}`, data)

export const sortBlocks = (
  lid: string,
  ids: string[]
): Promise<AxiosResponse> => patch(`/courses/lessons/${lid}/blocks`, { ids })

export const sortModuleScreenBlocks = (
  sid: string,
  ids: string[]
): Promise<AxiosResponse> =>
  patch(`/courses/module-screens/${sid}/blocks`, { ids })

export const deleteBlock = (block_id: string): Promise<AxiosResponse> =>
  del(`/courses/blocks/${block_id}`)

export const createBlock = (
  data: DataCreateBlockType
): Promise<AxiosResponse> => post('/courses/blocks', data)

export const attachLessonBlock = (
  lid: string,
  block_id: string,
  position: number
): Promise<AxiosResponse> =>
  post(`/courses/lessons/${lid}/blocks/${block_id}`, { position })

export const createSimpleTask = (
  notion_page_id: string | null,
  caption: string,
  description: string,
  show_field: number,
  field_caption: string,
  field_required: number,
  show_file: number,
  file_caption: string,
  file_required: number,
  task_required: number
): Promise<AxiosResponse> =>
  post('/courses/simple-tasks', {
    notion_page_id,
    caption,
    description,
    show_field,
    field_caption,
    field_required,
    show_file,
    file_caption,
    file_required,
    task_required,
  })

export const updateSimpleTask = (
  simple_task_id: string,
  notion_page_id: string | null,
  caption: string,
  description: string,
  show_field: number,
  field_caption: string,
  field_required: number,
  show_file: number,
  file_caption: string,
  file_required: number,
  task_required: number
): Promise<AxiosResponse> =>
  patch(`/courses/simple-tasks/${simple_task_id}`, {
    notion_page_id,
    caption,
    description,
    show_field,
    field_caption,
    field_required,
    show_file,
    file_caption,
    file_required,
    task_required,
  })

export const fetchModules = (course_id: string): Promise<AxiosResponse> =>
  get(`/courses/courses/${course_id}/modules`)

export const fetchSimpleTaskNotion = (
  simple_task_id: string
): Promise<AxiosResponse> => post(`/courses/simple-tasks/${simple_task_id}`)

export const fetchNotion = (
  block_id: string,
  block_notion_id: string
): Promise<AxiosResponse> =>
  post(`/courses/blocks/${block_id}/notion/${block_notion_id}`)
